function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import { isObject } from '@finect/front-utils/isObject';
import { getFundDisplayName } from './funds';
var productTypes = {
  fund: {
    id: 'fund',
    api: 'funds',
    apiSubtype: 'fund',
    slug: 'fondos-inversion',
    slugs: ['fondos-inversion', 'fondos'],
    singular: 'Fondo de inversión',
    plural: 'Fondos de inversión',
    shortSingular: 'Fondo',
    shortPlural: 'Fondos',
    category: 'iic',
    tag: 'fondos-de-inversion',
    views: ['home', 'sheet', 'comparison']
  },
  plans: {
    id: 'plan',
    api: 'plans',
    apiSubtype: 'plan',
    slug: 'planes-pensiones',
    slugs: ['planes-pensiones', 'planes'],
    singular: 'Plan de pensiones',
    plural: 'Planes de pensiones',
    shortSingular: 'Plan',
    shortPlural: 'Planes',
    category: 'iic',
    tag: 'jubilacion',
    views: ['home', 'sheet', 'comparison']
  },
  etf: {
    id: 'etf',
    api: 'etfs',
    apiSubtype: 'etf',
    slug: 'etfs',
    singular: 'ETF',
    plural: 'ETFs',
    shortSingular: 'ETF',
    shortPlural: 'ETFs',
    category: 'iic',
    tag: 'etfs',
    views: ['home', 'sheet', 'comparison'],
    acronym: true
  },
  sicav: {
    id: 'sicav',
    api: 'sicavs',
    apiSubtype: 'sicav',
    slug: 'sicavs',
    singular: 'SICAV',
    plural: 'SICAVs',
    shortSingular: 'SICAV',
    shortPlural: 'SICAVs',
    category: 'iic',
    tag: 'sicavs',
    views: ['comparison'],
    acronym: true
  },
  stock: {
    id: 'stock',
    api: 'stocks',
    apiSubtype: 'stock',
    slug: 'acciones',
    singular: 'accion',
    plural: 'Acciones',
    shortSingular: 'Acción',
    shortPlural: 'Acciones',
    category: 'stock',
    tag: 'bolsa',
    views: []
  },
  managedaccount: {
    id: 'managedaccount',
    api: 'managedaccounts',
    slug: 'cuentas-gestionadas',
    singular: 'Cuenta gestionada',
    plural: 'Cuentas gestionadas',
    shortSingular: 'Cuenta gestionada',
    shortPlural: 'Cuentas gestionadas',
    category: 'content',
    tag: null,
    views: ['sheet', 'comparison']
  },
  estate: {
    id: 'estate',
    api: 'estates',
    slug: 'inmobiliario',
    singular: 'Inmobiliario',
    plural: 'Inmobiliario',
    shortSingular: 'Inmobiliario',
    shortPlural: 'Inmobiliario',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  startup: {
    id: 'startup',
    api: 'startups',
    slug: 'startups',
    singular: 'Startup',
    plural: 'Startups',
    shortSingular: 'Startup',
    shortPlural: 'Startups',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  ipo: {
    id: 'ipo',
    api: 'ipos',
    slug: 'ipo',
    singular: 'Oferta pública de venta',
    plural: 'Ofertas públicas de venta',
    shortSingular: 'OPV',
    shortPlural: 'OPVs',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  insurance: {
    id: 'insurance',
    api: 'insurances',
    slug: 'seguros',
    singular: 'Seguro',
    plural: 'Seguros',
    shortSingular: 'Seguro',
    shortPlural: 'Seguros',
    category: 'content',
    tag: 'seguros',
    views: ['sheet']
  },
  'invest-service': {
    id: 'invest-service',
    api: 'invest-services',
    slug: 'servicios-inversion',
    singular: 'Servicio de inversión',
    plural: 'Servicios de inversión',
    shortSingular: 'Servicio de inversión',
    shortPlural: 'Servicios de inversión',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  paidaccount: {
    id: 'paidaccount',
    api: 'paidaccounts',
    slug: 'cuentas-remuneradas',
    singular: 'Cuenta remunerada',
    plural: 'Cuentas remunerada',
    shortSingular: 'Cuenta remunerada',
    shortPlural: 'Cuentas remunerada',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  service: {
    id: 'service',
    api: 'services',
    slug: 'servicios',
    singular: 'Servicio',
    plural: 'Servicios',
    shortSingular: 'Servicio',
    shortPlural: 'Servicios',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  roboadvisor: {
    id: 'roboadvisor',
    api: 'roboadvisors',
    slug: 'roboadvisors',
    singular: 'Roboadvisor',
    plural: 'Roboadvisors',
    shortSingular: 'Roboadvisor',
    shortPlural: 'Roboadvisors',
    category: 'content',
    tag: 'roboadvisors',
    views: ['sheet', 'comparison']
  },
  deposit: {
    id: 'deposit',
    api: 'deposits',
    slug: 'depositos',
    singular: 'Depósito',
    plural: 'Depósitos',
    shortSingular: 'Depósito',
    shortPlural: 'Depósitos',
    category: 'content',
    tag: 'depositos',
    views: ['sheet', 'comparison']
  },
  pias: {
    id: 'pias',
    api: 'pias',
    slug: 'pias',
    singular: 'PIAS',
    plural: 'PIAS',
    shortSingular: 'PIAS',
    shortPlural: 'PIAS',
    category: 'content',
    tag: 'seguros-ahorro',
    views: ['sheet']
  },
  savingsaccount: {
    id: 'savingsaccount',
    api: 'savingsaccounts',
    slug: 'cuentas-ahorro',
    singular: 'Cuenta de ahorro',
    plural: 'Cuentas de ahorro',
    shortSingular: 'Cuenta',
    shortPlural: 'Cuentas',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  unitlink: {
    id: 'unitlink',
    api: 'unitlinks',
    slug: 'unit-linked',
    singular: 'Unit linked',
    plural: 'Unit linked',
    shortSingular: 'Unit linked',
    shortPlural: 'Unit linked',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  sialp: {
    id: 'sialp',
    api: 'sialps',
    slug: 'sialps',
    singular: 'SIALP',
    plural: 'SIALPs',
    shortSingular: 'SIALP',
    shortPlural: 'SIALPs',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  book: {
    id: 'book',
    api: 'books',
    slug: 'libros',
    singular: 'Libro',
    plural: 'Libros',
    shortSingular: 'Libro',
    shortPlural: 'Libros',
    category: 'content',
    tag: null,
    views: ['sheet']
  },
  course: {
    id: 'course',
    api: 'courses',
    slug: 'cursos',
    singular: 'Curso',
    plural: 'Cursos',
    shortSingular: 'Curso',
    shortPlural: 'Cursos',
    category: 'content',
    tag: null,
    views: ['sheet', 'comparison']
  },
  savingsinsurance: {
    id: 'savingsinsurance',
    api: 'savingsinsurances',
    slug: 'seguros-ahorro',
    singular: 'Seguro de ahorro',
    plural: 'Seguros de ahorro',
    shortSingular: 'Seguro de ahorro',
    shortPlural: 'Seguros de ahorro',
    category: 'content',
    tag: 'seguros-ahorro',
    views: ['sheet']
  },
  crypto: {
    id: 'crypto',
    api: 'cryptos',
    slug: 'criptos',
    singular: 'Cripto',
    plural: 'Criptoactivos',
    shortSingular: 'Cripto',
    shortPlural: 'Criptos',
    category: 'content',
    tag: 'bitcoin-criptomonedas',
    views: ['sheet']
  },
  nft: {
    id: 'nft',
    api: 'nfts',
    slug: 'nfts',
    singular: 'NFT',
    plural: 'NFTs',
    shortSingular: 'NFT',
    shortPlural: 'NFTs',
    category: 'content',
    tag: 'bitcoin-criptomonedas',
    views: ['sheet']
  },
  token: {
    id: 'token',
    api: 'tokens',
    slug: 'tokens',
    singular: 'Token',
    plural: 'Tokens',
    shortSingular: 'Token',
    shortPlural: 'Tokens',
    category: 'content',
    tag: 'bitcoin-criptomonedas',
    views: ['sheet', 'comparison']
  },
  wallet: {
    id: 'wallet',
    api: 'wallets',
    slug: 'wallets',
    singular: 'Wallet',
    plural: 'Wallets',
    shortSingular: 'Wallet',
    shortPlural: 'Wallets',
    category: 'content',
    tag: 'bitcoin-criptomonedas',
    views: ['sheet', 'comparison']
  },
  card: {
    id: 'card',
    api: 'cards',
    slug: 'tarjetas',
    singular: 'Tarjeta',
    plural: 'Tarjetas',
    shortSingular: 'Tarjeta',
    shortPlural: 'Tarjetas',
    category: 'content',
    tag: null,
    views: ['sheet', 'comparison']
  },
  crowdfunding: {
    id: 'crowdfunding',
    api: 'crowdfunding',
    slug: 'crowdfunding',
    singular: 'Crowdfunding',
    plural: 'Crowdfunding',
    shortSingular: 'Crowdfunding',
    shortPlural: 'Crowdfunding',
    category: 'content',
    tag: 'crowd',
    views: ['sheet', 'comparison']
  },
  'overnight-money': {
    id: 'overnight-money',
    api: 'overnight-money',
    slug: 'cuentas',
    singular: 'Cuenta de ahorro',
    plural: 'Cuentas de ahorro',
    shortSingular: 'Cuenta',
    shortPlural: 'Cuentas',
    category: 'content',
    tag: null,
    views: ['sheet']
  }
};
export var getProductTypeLabel = function getProductTypeLabel(productType, format) {
  var transform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'none';
  var text = productType[format];
  if (['lowercase'].includes(transform)) {
    return productType.acronym ? text : text.toLowerCase();
  }
  return text;
};
var getProductTypesByCategory = function getProductTypesByCategory(category) {
  return Object.values(productTypes).filter(function (element) {
    return element.category === category;
  });
};
var getProductTypeBySlug = function getProductTypeBySlug(alias) {
  return Object.values(productTypes).find(function (_ref) {
    var slug = _ref.slug,
      _ref$slugs = _ref.slugs,
      slugs = _ref$slugs === void 0 ? [] : _ref$slugs;
    return slug === alias || slugs.includes(alias);
  });
};
var getProductTypeByAPISubtype = function getProductTypeByAPISubtype(id) {
  return Object.values(productTypes).find(function (element) {
    return element.apiSubtype === id;
  });
};
var getProductTypeById = function getProductTypeById(id) {
  return Object.values(productTypes).find(function (element) {
    return element.id === id;
  });
};
var getProductMetadescription = function getProductMetadescription(product, productType) {
  return "Rentabilidad, cartera, review y preguntas sobre el ".concat(productType.shortSingular, " ").concat(product.name);
};
var getProductName = function getProductName(product, productType) {
  return getFundDisplayName(product, productType);
};
var getProductTitle = function getProductTitle(product, productType) {
  return "".concat(getProductName(product, productType), " - ").concat(productType.plural);
};
export { productTypes, getProductTypeById, getProductTypeBySlug, getProductTypeByAPISubtype, getProductTypesByCategory, getProductMetadescription, getProductTitle, getProductName };
export var getProductPath = function getProductPath(product) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var productType = getProductTypeById(product.subtype);
  var contextString = context.length ? "#?".concat(context.filter(function (el) {
    return el.id !== 'producto';
  }).map(function (cont) {
    return "".concat(cont.id, "=").concat(cont.model.alias);
  }).join('&')) : '';
  if (!productType) {
    return '#';
  }
  switch (productType.category) {
    case 'content':
      return "/".concat(productType.slug, "/").concat(product.entity.alias).concat(contextString);
    case 'iic':
      return "/".concat(productType.slug, "/").concat(product.entity.isin, "-").concat(product.entity.alias).concat(contextString);
    default:
      return '#';
  }
};
var ValidationError = function (_Error) {
  _inherits(ValidationError, _Error);
  var _super = _createSuper(ValidationError);
  function ValidationError(attrName, modelName, model) {
    var _this;
    _classCallCheck(this, ValidationError);
    var id = model && isObject(model) && model.id ? model.id : null;
    var message = "Missing required parameter in \"".concat(modelName).concat(id ? " (".concat(id, ")") : '', "\" model: ").concat(attrName);
    _this = _super.call(this, message);
    _this.name = 'ValidationError';
    _this.model = model;
    return _this;
  }
  return _createClass(ValidationError);
}(_wrapNativeSuper(Error));
export var getProductDisplayName = function getProductDisplayName(product) {
  var name = ['plan'].includes(product.subtype) ? isObject(product.entity.class) ? product.entity.class.name : product.entity.class : product.entity.name;
  if (!name) {
    throw new ValidationError(['plan'].includes(product.subtype) ? 'product.entity.class.name' : 'product.entity.name', 'product', product.entity);
  }
  return name;
};
var BUY_LABEL = 'Me interesa';
var DEFAULT_ACTION = {
  icon: 'ShoppingCart',
  action: BUY_LABEL
};
export var getProductAction = function getProductAction(product) {
  var productType = getProductTypeById(product.subtype);
  switch (productType.category) {
    case 'content':
      {
        var commercialization = product.entity.commercializations.find(function (comm) {
          return comm.relationship === 'distributor';
        });
        return commercialization ? {
          icon: commercialization.icon,
          action: commercialization.action
        } : DEFAULT_ACTION;
      }
    case 'iic':
      {
        var _commercialization = product.entity.commercializations.find(function (comm) {
          return comm.relationship === 'distributor' && comm.security.id === product.entity.id;
        });
        return _commercialization ? {
          icon: _commercialization.icon,
          action: _commercialization.action
        } : DEFAULT_ACTION;
      }
    default:
      return DEFAULT_ACTION;
  }
};